import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const CardiologyIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8 13.5L3.5 9C2 7.5 2 5 3.5 3.5C5 2 7 2 8 3C9 2 11 2 12.5 3.5C14 5 14 7.5 12.5 9L8 13.5Z"
        stroke="#990000"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M4 6.5H5L5.5 7.5L6.5 5.5L7 6.5H8"
        stroke="#990000"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
